"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserOption = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _Avatar = require("../Avatar");

var _react = require("react");

var _data = require("../../../global-files/data");

var _utils = require("../../organisms/OrderDetail/utils/Table/utils");

var _UserSelector = require("../UserSelector");

var _customHooks = require("../../../global-files/customHooks");

var _jsxRuntime = require("react/jsx-runtime");

var UserOption = function UserOption(_ref) {
  var userId = _ref.userId,
      index = _ref.index,
      usersArray = _ref.usersArray,
      id = _ref.id,
      onAssign = _ref.onAssign,
      product = _ref.product;
  index === "auditor" && console.log(userId);

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      userAssigned = _useState2[0],
      setUserAssigned = _useState2[1];

  var _useCloseModal = (0, _customHooks.useCloseModal)(id),
      _useCloseModal2 = (0, _slicedToArray2.default)(_useCloseModal, 2),
      showSelector = _useCloseModal2[0],
      setShowSelector = _useCloseModal2[1];

  var _useState3 = (0, _react.useState)(""),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      assignationTarget = _useState4[0],
      setAssignationTarget = _useState4[1];

  var _useState5 = (0, _react.useState)(""),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      concept = _useState6[0],
      setConcept = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      target = _useState8[0],
      setTarget = _useState8[1];

  var icons = _utils.servicesCodeIcon;
  (0, _react.useEffect)(function () {
    if (usersArray) {
      usersArray.forEach(function (user) {
        if (user.id_user === userId) {
          setUserAssigned(user);
        }
      });
    }
  }, [userId, usersArray]);
  (0, _react.useEffect)(function () {
    switch (index) {
      case "datasheet":
      case "description":
        setAssignationTarget("id_".concat(index, "_especialist"));
        setConcept(index);
        setTarget("especialist");
        break;

      case "image":
        setAssignationTarget("id_".concat(index, "s_especialist"));
        setConcept(index + "s");
        setTarget("especialist");
        break;

      case "auditor":
        setAssignationTarget("id_".concat(index));
        setConcept(index);
        setTarget(index);
        break;

      default:
        break;
    }
  }, [index]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    onClick: function onClick(e) {
      setShowSelector(!showSelector);
      e.stopPropagation();
    },
    id: id,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "image-and-name",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Avatar.Avatar, {
        image: (0, _data.getProfilePicture)(userAssigned === null || userAssigned === void 0 ? void 0 : userAssigned.id_user, 26, 26),
        altText: "datasheet especialist",
        imageType: "medium-image"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        children: [userAssigned === null || userAssigned === void 0 ? void 0 : userAssigned.name, " ", userAssigned === null || userAssigned === void 0 ? void 0 : userAssigned.last_name]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "icon-container",
      children: icons[index]
    }), showSelector && /*#__PURE__*/(0, _jsxRuntime.jsx)(_UserSelector.UserSelector, {
      id: id,
      searchLabel: "Buscar Usuario",
      index: index,
      usersArray: usersArray,
      position: "absolute",
      onAssign: onAssign,
      product: product,
      assignationTarget: assignationTarget,
      target: target,
      concept: concept
    })]
  });
};

exports.UserOption = UserOption;